import Anchor from 'antd/es/anchor/Anchor';
export default Anchor;
